"use client";
import a from "react";
function t(r) {
  return r !== null && typeof r == "object" && !Array.isArray(r);
}
function f(r, ...n) {
  return n.forEach((e) => {
    Object.keys(e).forEach((s) => {
      t(e[s]) && t(r[s]) ? r[s] = f(r[s], e[s]) : r[s] = e[s];
    });
  }), r;
}
function u(r) {
  return /<[^>]+>/g.test(r);
}
function p(r) {
  const n = [];
  return a.Children.forEach(r, (e) => {
    e && (Array.isArray(e) ? n.push(...p(e)) : e.type && (e.type.displayName === "Option" || e.type.name === "Option" || e.type.displayName === "Tab" || e.type.name === "Tab") ? n.push(e) : e.props && e.props.children && n.push(...p(e.props.children)));
  }), n;
}
export {
  p as f,
  u as h,
  f as m
};
